// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#articleSummary{font-size:10px;font-style:italic;white-space:pre-wrap}.divider{height:0;margin-top:.7rem;margin-bottom:-.22rem;overflow:hidden;border-top:1px solid hsla(0,0%,66.7%,.6666666666666666)}", ""]);
// Exports
module.exports = exports;
